import React from 'react';
import PropTypes from 'prop-types';

import AjaxHelper from '../common/AjaxHelper';
import SessionHelper from '../common/SessionHelper';
import TranslationHelper from '../common/TranslationHelper';
import UIHelper from '../common/UIHelper';

import '../css/admin/css/style.css';
import SignUp from '../components/signup/layout/SignUp';

export default class UNAUTHORIZED extends React.Component {
	static contextTypes = {
		router: PropTypes.object
	}

	constructor(props, context) {
		super(props, context);
		this.state = {
			openModal: false
		};
	}

	componentDidMount() {
		AjaxHelper.invokeServerAPI('/api/customerLogin', {}, (err, data) => {
			if (!err) {
				UIHelper.savePageForAuthentication(window.location.pathname, this.props.location.state);
				if (data.result && data.result.customerLogin) {
					this.layout = data.result.customerLogin.layout;

					if (this.layout !== 'default' && !SessionHelper.getSessionUser()) {
						UIHelper.showPageReplace(this, '/login', {});
					} else {
						this.setState({ openModal: true });
					}
				} else {
					this.setState({ openModal: true });
				}
			}
		});
	}

	render() {
		return (
			<>
				{this.state.openModal && <SignUp openModal />}
				<div className="error" style={{ marginTop: '75px' }}>
					<div className="error-code m-b-10">
						{TranslationHelper.getValue('customer_account.unauthorized.login')}
						<i className="fa fa-warning" />
					</div>
					<div className="error-content">

						<div>
							<a href="/" className="btn btn-success">
								{TranslationHelper.getValue('customer_account.unauthorized.backToHomePage')}
							</a>
						</div>
					</div>
				</div>
			</>
		);
	}
}
